// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__k9VlZ","footer":"Form_footer__2a-n9"};